import { IAnnotation, IAnnotationType } from '../../../types/record/annotation';
import {
  AnnotationAPIRawSuccessResponseType,
  AnnotationAPIRawValidationErrorType,
  CreateAnnotationAPIRawValidationErrorType,
  IAnnotationAPIValidationErrorFactory,
  IAnnotationAPIValidationErrorType,
  ICreateAnnotationAPIValidationErrorFactory,
  ICreateAnnotationAPIValidationErrorType
} from '../../types/annotation/api-response';
import { RawRectangleToIRect } from '../../types/common/raw-rectangle';
import { nullableToStringList } from '../nullable-to-string-list';

export const IAnnotationFromAPISuccessResponse = ({
  label,
  uid,
  rectangle
}: AnnotationAPIRawSuccessResponseType): IAnnotationType =>
  IAnnotation({
    uuid: uid,
    labelId: label,
    rect: RawRectangleToIRect(rectangle)
  });

export const IAnnotationAPIValidationError = ({
  label,
  rectangle
}: AnnotationAPIRawValidationErrorType): IAnnotationAPIValidationErrorType =>
  IAnnotationAPIValidationErrorFactory({
    labelId: nullableToStringList(label),
    rect: nullableToStringList(rectangle)
  });

// for create api

export const ICreateAnnotationAPIValidationError = ({
  uid,
  label,
  rectangle
}: CreateAnnotationAPIRawValidationErrorType): ICreateAnnotationAPIValidationErrorType =>
  ICreateAnnotationAPIValidationErrorFactory({
    uuid: nullableToStringList(uid),
    labelId: nullableToStringList(label),
    rect: nullableToStringList(rectangle)
  });
